module.exports = __webpack_public_path__ + "79883954c45e05f3cf2c26d4c0554f34.pdf";